module.exports = __webpack_public_path__ + "img/FCBAquadri1ligne-logo.dadec77b.png";